// extracted by mini-css-extract-plugin
export default {"date-picker-icon-btn":"date-picker-input_date-picker-icon-btn__WNuEY"};